// extracted by mini-css-extract-plugin
module.exports = {"advProductList":"index-module_advProductList_Cm51p"};